// Modules
import { useEffect, useRef, useState } from "react";

// Utils
import { navbarItemsHandler } from "utils/shared/navbar";

// Redux
import {useAppSelector} from "redux/hooks";
import {htmlHeaderSelector} from "redux/shared/userInfoSlice";

// Definitions
declare global {
	interface Window {
		initNavbar: boolean;
	}
}

interface NavbarItemProps {
	setIsCorporateHatOpen: (isCorporateHatOpen: boolean) => void;
	setCorpHatAccordionStates: (corpHatAccordionStates: boolean[]) => void;
	htmlHeaderClientSide: string;
}

const NavbarItems = ({setIsCorporateHatOpen, setCorpHatAccordionStates, htmlHeaderClientSide }: NavbarItemProps) => {
	const htmlHeader = useAppSelector(htmlHeaderSelector);
	const effectiveHtmlHeader = htmlHeader || htmlHeaderClientSide;

	const [isClient, setIsClient] = useState(false);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		setIsClient(true);
	}, []);

	useEffect(() => {
		if (isClient && containerRef.current && containerRef.current.innerHTML.trim() !== "" && !window.initNavbar)
		{
			window.initNavbar = true;
			navbarItemsHandler(setIsCorporateHatOpen, setCorpHatAccordionStates);
		}
	}, [isClient, effectiveHtmlHeader]);

	return (
		<div
			ref={containerRef}
			id="ctl00_MasterHeader_MainContent_pBoxStaticRaw"
			dangerouslySetInnerHTML={{ __html: effectiveHtmlHeader }}
		/>
	);
};


export default NavbarItems;
